// Routes ///////////////////////////////////////////////////////////////
export const ProfilePackagesRoute = (activePackage?: boolean): string =>
  `/profile/${activePackage ? `?activePackage=true` : ''}`;
export const ProfileChangePasswordRoute = (): string =>
  '/profile/change-password';
export const ProfileCreatePasswordRoute = (): string =>
  '/profile/create-password';
export const ProfileInformationRoute = (): string => '/profile/information';

// API //////////////////////////////////////////////////////////////////
export const ProfileInformationUrl = (): string => '/api/v1/account/profile/';

export const ChangePasswordUrl = (): string =>
  `/api/v1/account/change_password/`;

export const CreatePasswordUrl = (): string => `/api/v2/accounts/set_password/`;

export const ProfileTransactionHistoryUrl = (): string =>
  '/api/v1/wallet/transaction_history/';

export const CreateInvoiceUrl = (id: string): string =>
  `/api/v1/wallet/create_invoice/${id}/`;

export const ActiveSessionUrl = (): string => `/api/v1/account/session/`;

export const DeleteSessionUrl = (id: string): string =>
  `/api/v1/account/session/${id}/`;

export const PurchasedPackagesUrl = (): string => '/api/v1/packages/purchased/';

export const GoftinoUrl = (): string => 'https://www.goftino.com/c/rzIlQn';

export const SupportNumber = (): string => '021 - 281 11 281';
